module.exports = __webpack_public_path__ + "img/龙猫.75782160.webp";